<ng-container *ngIf="!hideBanner && bannerData">
  <div
    class="global-banner"
    role="alert"
    [class.error-banner]="bannerData?.bannerType?.toLowerCase() === 'error'"
    [class.warning-banner]="bannerData?.bannerType?.toLowerCase() === 'warning'"
    [class.success-banner]="bannerData?.bannerType?.toLowerCase() === 'success'"
    [class.info-banner]="bannerData?.bannerType?.toLowerCase() === 'info'">
    <mat-icon *ngIf="bannerData?.bannerType?.toLowerCase() === 'error'" aria-hidden="true">error_outline</mat-icon>
    <mat-icon *ngIf="bannerData?.bannerType?.toLowerCase() === 'warning'" aria-hidden="true">warning</mat-icon>
    <mat-icon *ngIf="bannerData?.bannerType?.toLowerCase() === 'success'" aria-hidden="true">check_circle</mat-icon>
    <mat-icon *ngIf="bannerData?.bannerType?.toLowerCase() === 'info'" aria-hidden="true">info</mat-icon>

    <span class="banner-text">
      {{ bannerData?.bannerText }}
      <ng-container *ngIf="bannerData?.bannerFileName && (bannerData?.id || bannerData?._id)">
        &nbsp;
        <a
          href
          (click)="onBannerFileClick($event, bannerData?.id || bannerData?._id, bannerData.bannerFileName)"
          [attr.aria-label]="(isPdf(bannerData.bannerFileName) ? 'Open ' : 'Download ') + bannerData.bannerFileName">
          {{ bannerData.bannerFileName }}
        </a>
      </ng-container>
    </span>
    <button type="button" class="close-icon" mat-icon-button (click)="setHideBanner(true)" aria-label="Close banner">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
</ng-container>
